module.exports = __webpack_public_path__ + "static/media/nonord-c-8.01559b82.mp3";